import { head } from 'lodash';

export default function getFormatPrice(format, region = 'GO') {
  const price = format?.prices?.find((price) => price?.region === region);

  return price || head(format?.prices) || { amount: 0 };
}
